/**
 * Nextdoor Event Listeners
 *
 * Uses the unified event system (pmw:pixel:*) with firing decisions.
 *
 * @see https://developer.nextdoor.com/reference/for-net-new-advertisers
 */

(function (pmw, undefined) {

	/**
	 * Load pixel on consent
	 */
	pmw.bus.on("pmw:load-pixels", function () {
		if (
			pmwDataLayer?.pixels?.nextdoor?.pixel_id &&
			!pmwDataLayer?.pixels?.nextdoor?.loaded &&
			pmw.consent.canPixelBeFired("marketing", "Nextdoor")
		) {
			pmw.loadNextdoorPixel();
		}
	});

	/**
	 * Page View event
	 *
	 * Fires on every page, mirroring the base code snippet. The shared
	 * event_id deduplicates the browser pixel against the Conversion API.
	 */
	pmw.bus.on("pmw:pixel:page-view", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * View Item event
	 *
	 * Fires on product detail pages.
	 */
	pmw.bus.on("pmw:pixel:view-item", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Add to Cart event
	 *
	 * Fires when a product is added to the cart.
	 */
	pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Begin Checkout event
	 *
	 * Fires when the checkout is started.
	 */
	pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Search event
	 *
	 * Fires on search result pages.
	 */
	pmw.bus.on("pmw:pixel:search", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Purchase / Order Received event
	 *
	 * Fires when a purchase is completed and the order received page is viewed.
	 */
	pmw.bus.on("pmw:pixel:purchase", (payload) => {
		if (!pmwDataLayer?.pixels?.nextdoor?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "nextdoor")) return;

		try {
			const nextdoorData = payload.pixels?.nextdoor;
			if (!nextdoorData) return;

			pmw.nextdoorTrackEvent(nextdoorData);
		} catch (e) {
			console.error(e);
		}
	});

}(window.pmw = window.pmw || {}));
